import {
  WebhookTriggerEvent,
  WebhookTriggerEventName,
} from '../../../enums/webhook';

export const getWebhookTriggerEventName = (
  trigger: WebhookTriggerEvent,
): WebhookTriggerEventName => {
  switch (trigger) {
    case WebhookTriggerEvent.EmailSent:
      return WebhookTriggerEventName.EmailSent;

    case WebhookTriggerEvent.EmailOpened:
      return WebhookTriggerEventName.EmailOpened;

    case WebhookTriggerEvent.EmailLinkClicked:
      return WebhookTriggerEventName.EmailLinkClicked;

    case WebhookTriggerEvent.ReplyReceived:
      return WebhookTriggerEventName.ReplyReceived;

    case WebhookTriggerEvent.EmailBounced:
      return WebhookTriggerEventName.EmailBounced;

    case WebhookTriggerEvent.ProspectUnsubscribed:
      return WebhookTriggerEventName.ProspectUnsubscribed;

    case WebhookTriggerEvent.ProspectFinished:
      return WebhookTriggerEventName.ProspectFinished;

    case WebhookTriggerEvent.ProspectOutcomeUpdated:
      return WebhookTriggerEventName.ProspectOutcomeUpdated;

    case WebhookTriggerEvent.InboxAnalyserTestCompleted:
      return WebhookTriggerEventName.InboxAnalyserTestCompleted;

    case WebhookTriggerEvent.TaskCreated:
      return WebhookTriggerEventName.TaskCreated;

    case WebhookTriggerEvent.LinkedinTaskUpdated:
      return WebhookTriggerEventName.LinkedinTaskUpdated;

    case WebhookTriggerEvent.CallTaskUpdated:
      return WebhookTriggerEventName.CallTaskUpdated;

    case WebhookTriggerEvent.WhatsAppTaskUpdated:
      return WebhookTriggerEventName.WhatsAppTaskUpdated;

    case WebhookTriggerEvent.CustomTaskUpdated:
      return WebhookTriggerEventName.CustomTaskUpdated;

    case WebhookTriggerEvent.BulkTaskUpdated:
      return WebhookTriggerEventName.BulkTaskUpdated;

    default:
      return null;
  }
};
